import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { MagicLetterBoxLink } from "@/components/funnel/MagicLetterBoxLink";
import { FAMILY_OFFER } from "../../shared/magic-letter-box";

interface SignUpDialogProps { open: boolean; onOpenChange: (open: boolean) => void; }

export default function SignUpDialog({ open, onOpenChange }: SignUpDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[90dvh] overflow-y-auto sm:max-w-md">
        <DialogTitle className="text-2xl font-bold">Keep the story going at The Magic Letter Box</DialogTitle>
        <DialogDescription className="text-base leading-relaxed">Elf Letter Bot is your free starting point for Christmas ideas and three personalized PDF deliveries per email address. For more, create a separate account at The Magic Letter Box.</DialogDescription>
        <p className="text-sm leading-relaxed">Start with {FAMILY_OFFER.trialLetters} free letters. Family membership is {FAMILY_OFFER.price} for unlimited letters, premium templates, saved history, and up to {FAMILY_OFFER.children} children.</p>
        <MagicLetterBoxLink source="navigation-signup">Create a Magic Letter Box account</MagicLetterBoxLink>
        <p className="text-xs text-slate-600">No credit card needed for the trial. You choose whether to upgrade.</p>
      </DialogContent>
    </Dialog>
  );
}
